<template>
  <div class="Exporthk5">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk5(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk5") }}
        </v-btn> -->
          <download-excel
              :data = "papardatahk5"
              type="csv"
              name="hk5.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk5") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk5"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk5",
  setup() {},
  props: [
    "papardatahk5",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      {text: "Bil", value: "Bil"},
      {text: "HID", value: "HID"},
      {text: "BNO", value: "BNO"},
      {text: "Pusingan", value: "Pusingan"},
      {text: "S", value: "S"},
      {text: "NG", value: "NG"},
      {text: "DP", value: "DP"},
      {text: "DB", value: "DB"},
      {text: "BP", value: "BP"},
      {text: "ST", value: "ST"},
      {text: "NOIR", value: "NOIR"},
      {text: "NOAIR", value: "NOAIR"},
      // {text: "KAW", value: "KAW"},
      // {text: "Bulan", value: "Bulan"},
      // {text: "Tahun", value: "Tahun"},
      // {text: "BPK", value: "BPK"},
      // {text: "IDBPK", value: "IDBPK"},
      {text: "HK5PK", value: "HK5PK"},
      {text: "HK5PN", value: "HK5PN"},
      {text: "HK5S26", value: "HK5S26"},
      {text: "HK5M", value: "HK5M"},
      {text: "HK5S38", value: "HK5S38"},
      {text: "HK5S39", value: "HK5S39"},
      {text: "HK5B1", value: "HK5B1"},
      {text: "HK5B2", value: "HK5B2"},
      {text: "HK5A1", value: "HK5A1"},
      {text: "HK5A2", value: "HK5A2"},
      {text: "HK5A3", value: "HK5A3"},
      {text: "HK5A4", value: "HK5A4"},
      {text: "HK5C1", value: "HK5C1"},
      {text: "HK5C2", value: "HK5C2"},
      {text: "HK5C3", value: "HK5C3"},
      {text: "HK5C4", value: "HK5C4"},
      {text: "HK521di", value: "HK521di"},
      {text: "HK521dii", value: "HK521dii"},
      {text: "HK521diii", value: "HK521diii"},
      {text: "HK5INCS21d", value: "HK5INCS21d"},
      {text: "HK5INCS21di", value: "HK5INCS21di"},
      {text: "HK5INCS21dii", value: "HK5INCS21dii"},
      {text: "HK5INCS21diii", value: "HK5INCS21diii"},
      {text: "HK5KL", value: "HK5KL"},
      // {text: "dateMula", value: "dateMula"},
      // {text: "dateTamat", value: "dateTamat"},
    ],
  }),
  methods: {
    async exportexcelhk5(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk5serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>